import React, { useState, useEffect, useCallback } from 'react';

const CONSENT_KEY = 'ivt-cookie-consent';
const CONSENT_GRANTED = 'granted';
const CONSENT_DENIED = 'denied';

/**
 * CookieConsent — GDPR-compliant cookie consent banner for IrishVisaTracker.
 */
export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (!stored) {
      setVisible(true);
    }
  }, []);

  const setConsent = useCallback((analyticsStorage) => {
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        analytics_storage: analyticsStorage,
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        functionality_storage: 'granted',
        security_storage: 'granted',
      });
    }
    localStorage.setItem(CONSENT_KEY, analyticsStorage);
    setVisible(false);
  }, []);

  const handleAccept = useCallback(() => {
    setConsent(CONSENT_GRANTED);
  }, [setConsent]);

  const handleReject = useCallback(() => {
    setConsent(CONSENT_DENIED);
  }, [setConsent]);

  if (!visible) return null;

  return (
    <div className="cookie-consent-overlay" role="dialog" aria-label="Cookie consent">
      <div className="cookie-consent-banner">
        <div className="cookie-consent-content">
          <p className="cookie-consent-text">
            We use cookies to improve your experience and analyze site traffic.
            You can choose to accept or reject analytics cookies.
            <a
              href="/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="cookie-consent-link"
            >
              Learn more
            </a>
          </p>
          <div className="cookie-consent-actions">
            <button
              type="button"
              className="cookie-btn cookie-btn-reject"
              onClick={handleReject}
            >
              Reject All
            </button>
            <button
              type="button"
              className="cookie-btn cookie-btn-accept"
              onClick={handleAccept}
            >
              Accept All
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
